import { Component, ViewEncapsulation, Input } from '@angular/core';
import { ErrorComponentDefinition } from '@formbird/types';

import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'ft-component-error',
  templateUrl: './component-error.component.html',
  styleUrls: ['./component-error.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  imports: [MatCardModule, MatIconModule]
})
export class ComponentErrorComponent {
  @Input() componentDefinition: ErrorComponentDefinition;
}
